module.exports = __webpack_public_path__ + "img/hdbt_logo.6de7b82e.svg";